const pokemonTypes = {
    normal: '#A8A77A',
    fire: '#EE8130',
    water: '#6390F0',
    grass: '#7AC74C',
    ground: '#E2BF65',
    bug: '#A6B91A',
    poison: '#A33EA1',
    electric: '#F7D02C',
    rock: '#B6A136',
    psychic: '#F95587',
    fighting: '#C22E28',
    fairy: '#D685AD',
    dragon: '#6F35FC',
    ice: '#96D9D6',
    default: '#232730',
    flying: '#A98FF3',
    ghost: '#735797',
    dark: '#705746',
    stell: '#B7B7CE'
};

export default pokemonTypes